module.exports = __webpack_public_path__ + "static/media/tinytattoo2-transformed.9bb29cd3.jpeg";